import * as React from 'react';
import {NavBar, Icon, Toast, Button} from 'antd-mobile';
import {Link} from 'react-router-dom';
import {WhiteSpace, WingBlank} from 'antd-mobile';

import dal from '../data/DAL';

let debug = require('debug')('APP:DownloadConfig')


/**
 * 连接帮助页面
 */
export default class DownloadConfig extends React.Component {

    downloadConfigFile = () => {
        debug('download config file');
        if (dal.getToken() === '') {
            // alert('请先充值或会员恢复');
            Toast.fail('请先充值或会员恢复');
            return;
        }
        dal.fetchConfigFileUrl().then(rsp => {
            debug(rsp)
            if (rsp.data.status === 0) {
                let downloadUrl = rsp.data.data.configUrl;
                window.location.href = downloadUrl;
            } else {
                Toast.fail(rsp.data.msg);
            }

        })

    };

    render() {
        return (
            <div className="App">
                <NavBar
                    mode="light"
                    icon={<Link to={"/home"}><Icon color={'#666666'} size={'lg'} type="left"/></Link>}
                    onLeftClick={() => console.log('onLeftClick')}
                    rightContent={[]}>
                    安装方法
                </NavBar>
                <WhiteSpace size="lg"/>
                <WingBlank size="lg">
                    {/*<div>*/}
                    {/*    <img style={{width: '50%'}} src={require('../images/1.png')} />*/}
                    {/*    <img style={{width: '50%'}} src={require('../images/2.png')} />*/}
                    {/*</div>*/}
                    {/*<div >*/}
                    {/*    <img style={{width: '100%'}} src={require('../images/3.png')} />*/}
                    {/*</div>*/}
                    <div style={{marginLeft: 40}}>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>1</span>
                            <span style={{color: '#222222'}}>下载配置文件</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <Button type="primary" size="small"
                                    style={{width: 85, marginLeft: 40}} onClick={this.downloadConfigFile}>点我下载</Button>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>2</span>
                            <span style={{color: '#222222'}}>进入系统设置</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>3</span>
                            <span style={{color: '#222222'}}>已下载描述文件</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>4</span>
                            <span style={{color: '#222222'}}>选择Raptor加速器配置</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <span className='custom-label'>5</span>
                            <span style={{color: '#222222'}}>点击安装</span>
                        </div>
                        <WhiteSpace size="lg"/>
                        <div>
                            <img style={{ width: 250, marginLeft: 40}} src={require('../images/install.png')}/>
                        </div>
                        <WhiteSpace size={"lg"}/>
                        <WhiteSpace size={"lg"}/>
                    </div>
                </WingBlank>
            </div>
        );
    }
}

